export enum PaymentType {
    directDebit = 0,
    card = 1,
}
